import axios from 'axios'

const state = {
  country: '',
  company: ''
}

const getters = {
  getAddressData(state) {
    return state
  },
  getCountries(state) {
    return state.countries
  }
}

const mutations = {
  setAddressData(state, data) {
    state.countries = data
  },
  setCountries(state, data) {
    state.countries = data
  }
}

const actions = {
  getCountries({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/api/countries',
        data: data
      })
        .then(response => {
          commit('setCountries', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
